'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _ComcastPetitionLetter = require('./ComcastPetitionLetter.css');

var _ComcastPetitionLetter2 = _interopRequireDefault(_ComcastPetitionLetter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ComcastPetitionLetter = (_dec = (0, _reactCssModules2.default)(_ComcastPetitionLetter2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(ComcastPetitionLetter, _Component);

  function ComcastPetitionLetter() {
    (0, _classCallCheck3.default)(this, ComcastPetitionLetter);
    return (0, _possibleConstructorReturn3.default)(this, (ComcastPetitionLetter.__proto__ || (0, _getPrototypeOf2.default)(ComcastPetitionLetter)).apply(this, arguments));
  }

  (0, _createClass3.default)(ComcastPetitionLetter, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'blockquote',
        { styleName: 'company-letter-blockquote' },
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'To: Comcast management'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'From: ',
            _react2.default.createElement(
              'i',
              null,
              'As You Sow'
            ),
            ' & concerned Comcast customers'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Investor-owned companies are profiting from exploitative prison labor, immigration jails, and other economic systems of oppression and exploitation. Mass incarceration is particularly devastating for poor communities, immigrants, people of color, and their families. As a company that directs millions of dollars in employee retirement savings towards companies profiting from the prison industrial complex, these issues expose you and your employees to a host of material risks.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Critically, the default 401(k) option for Comcast employees is not invested sustainably. Over 50% of assets invested in the plan are in the default target date funds from Vanguard. Because these funds are not invested sustainably, millions of dollars in employee savings are being allocated to prison and border industry investments.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Comcast has the unique opportunity to become an industry leader and help shift millions of dollars away from the prison industrial complex. You have tremendous power \u2013 and the world needs you to start using that power responsibly. I urge you to live up to your public commitments by offering a prison-free default retirement fund.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Thank you.'
        )
      );
    }
  }]);
  return ComcastPetitionLetter;
}(_react.Component)) || _class);
exports.default = ComcastPetitionLetter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ComcastPetitionLetter/ComcastPetitionLetter.js
// module id = 1377
// module chunks = 0